<template>
    <div component="layout" class="layout" :id="options.id" :class="{'no-user-select': resizing}">
        <div class="north region" :style="{height:northHeight}">
            <div class="body" ref="north" :style="{padding:getPadding('north')}"></div>
            <i
                class="north-center split"
                v-if="getCanResize('north')"
                @mousedown="dragDown($event, 'north')"
                @mouseup="dragSigh($event)"
            ></i>
        </div>
        <div class="center-container">
            <div class="west region" :style="{width:westWidth }">
                <div class="body" ref="west" :style="{padding:getPadding('west')}">
                    <slot name="west"></slot>
                </div>
                <i
                    class="west-center split"
                    v-if="getCanResize('west')"
                    @mousedown="dragDown($event, 'west')"
                    @mouseup="dragSigh($event)"
                ></i>
            </div>
            <div class="center region">
                <div class="body" ref="center" :style="{padding:getPadding('center')}">
                    <slot name="center"></slot>
                </div>
            </div>
            <div class="east region" :style="{width:eastWidth}">
                <div class="body" ref="east" :style="{padding:getPadding('east')}">
                    <slot name="east"></slot>
                </div>
                <i
                    class="center-east split"
                    v-if="getCanResize('east')"
                    @mousedown="dragDown($event, 'east')"
                    @mouseup="dragSigh($event)"
                ></i>
            </div>
        </div>
        <div class="south region" :style="{height:southHeight}">
            <div class="body" ref="south" :style="{padding:getPadding('south')}">
                <slot name="south"></slot>
            </div>
            <i
                class="center-south split"
                v-if="getCanResize('south')"
                @mousedown="dragDown($event, 'south')"
                @mouseup="dragSigh($event)"
            ></i>
        </div>
    </div>
</template>

<script>
import Gikam from "../../core/gikam-core.js";
export default {
    name: "layout",

    props: {
        options: Object
    },

    data() {
        return {
            northHeight: this.options.north.height,
            southHeight: this.options.south.height,
            westWidth: this.options.west.width,
            eastWidth: this.options.east.width,
            initX: null,
            initY: null,
            resizing: false,
            direction: null
        };
    },

    watch: {
        "options.north.height"(value) {
            this.northHeight = value;
        },
        "options.south.height"(value) {
            this.southHeight = value;
        },
        "options.west.width"(value) {
            this.westWidth = value;
        },
        "options.east.width"(value) {
            this.eastWidth = value;
        }
    },

    methods: {
        dragDown(e, direction) {
            // 解决layout嵌套iframe时，拖动卡顿问题。按下时宽高100%，松开时还原宽度，高。
            Gikam.jQuery(e.target).addClass("drag-drop");
            this.initX = e.pageX;
            this.initY = e.pageY;
            this.resizing = true;
            this.direction = direction;
            document.addEventListener("mousemove", this.dragMove, false);
            document.addEventListener("mouseup", this.dragUp, false);
        },

        // 解决layout嵌套iframe时，拖动卡顿问题。按下时宽高100%，松开时还原宽度，高。
        dragSigh(e) {
            Gikam.jQuery(e.target).removeClass("drag-drop");
        },

        dragMove(e) {
            if (!this.resizing) return;
            let northHeight = this.$el.querySelector(".north.region")
                .offsetHeight;
            let southHeight = this.$el.querySelector(".south.region")
                .offsetHeight;
            let centerHeight = this.$el.querySelector(".center-container")
                .offsetHeight;
            let centerWidth = this.$el.querySelector(".center.region")
                .offsetWidth;
            let westWidth = this.$el.querySelector(".west.region").offsetWidth;
            let eastWidth = this.$el.querySelector(".east.region").offsetWidth;
            if (this.direction === "north" || this.direction === "south") {
                let distance = e.pageY - this.initY;
                if (Math.abs(distance) < 3) return;
                if (this.direction === "north") {
                    if (distance > 0 && centerHeight < 50) return;
                    if (distance < 0 && northHeight < 50) return;
                    this.northHeight = northHeight + distance + "px";
                }
                if (this.direction === "south") {
                    if (distance < 0 && centerHeight < 50) return;
                    if (distance > 0 && southHeight < 50) return;
                    this.southHeight = southHeight - distance + "px";
                }
                this.initY = e.pageY;
            } else if (this.direction === "west" || this.direction === "east") {
                let distance = e.pageX - this.initX;
                if (Math.abs(distance) < 3) return;
                if (this.direction === "west") {
                    if (distance < 0 && westWidth < 50) return;
                    if (distance > 0 && centerWidth < 50) return;
                    this.westWidth = westWidth + distance + "px";
                }
                if (this.direction === "east") {
                    if (distance < 0 && centerWidth < 50) return;
                    if (distance > 0 && eastWidth < 50) return;
                    this.eastWidth = eastWidth - distance + "px";
                }
                this.initX = e.pageX;
            }
        },

        dragUp() {
            this.$emit("resize", this.direction);
            this.initX = null;
            this.initY = null;
            this.resizing = false;
            this.direction = null;
            document.removeEventListener("mousemove", this.dragMove, false);
            document.removeEventListener("mouseup", this.dragUp, false);
        },

        getPadding(direction) {
            return this.options[direction].padding || "";
        },

        getCanResize(direction) {
            if (direction === "south" || direction === "north") {
                return (
                    parseInt(this.options[direction].height) > 0 &&
                    (this.options[direction].resize || this.options.resize)
                );
            } else if (direction === "east" || direction === "west") {
                return (
                    parseInt(this.options[direction].width) > 0 &&
                    (this.options[direction].resize || this.options.resize)
                );
            }
        },

        handleResize() {
            this.$nextTick(() => {
                const gridDoms = this.$el.querySelectorAll(".grid");
                for (let i = 0; i < gridDoms.length; i++) {
                    Gikam.getInstance(
                        gridDoms[i]
                    ).model.$children[0].handleBtnMore();
                }
            });
        }
    }
};
</script>

<style scoped>
.layout {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
}

.center-container {
    display: flex;
    flex: 1;
    overflow: hidden;
}

.layout > .center-container > .center {
    flex: 1;
}

.layout > .center-container > .center,
.layout > .center-container > .north,
.layout > .center-container > .south,
.layout > .center-container > .west,
.layout > .center-container > .east {
    position: relative;
}

.layout > .center-container > .region > .split.center-east,
.layout > .center-container > .region > .split.west-center {
    position: absolute;
    width: 6px;
    height: 100%;
    background-color: transparent;
    cursor: ew-resize;
    z-index: 2;
}

.layout > .center-container > .region > .split.west-center {
    right: 0;
}

.layout > .center-container > .region > .split.center-east {
    left: 0;
}

.layout > .region > .split.north-center,
.layout > .region > .split.center-south {
    position: absolute;
    height: 6px;
    width: 100%;
    background-color: transparent;
    cursor: ns-resize;
    z-index: 2;
}

.layout > .region > .split.north-center {
    bottom: 0;
}

.layout > .region > .split.center-south {
    top: 0;
}

.layout .region {
    position: relative;
}

.body {
    height: 100%;
    overflow: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.no-user-select {
    user-select: none;
}

.west > .body >>> .tab {
    padding-right: 0;
}

.layout .region {
    transition: width 0.3s, height 0.3s;
}

.layout.no-user-select .region {
    transition: none;
}
</style>

<style>
.layout > .center-container > .west > .body > .grid {
    padding-right: 0;
}

.layout > .center-container > .east > .body > .grid {
    padding-left: 0;
}

.layout > .center-container > .region > .split.drag-drop {
    /* 这里不加!important覆盖不了 */
    width: 100% !important;
    height: 100% !important;
}
</style>